import { withNonDigitalProductListingByCategory } from '../Hocs/withNonDigitalProductListingByCategory'
import MobileFilters from '../MobileFilters'
import { MobileNonDigitalProductsListingCard } from './MobileNonDigitalProductsListingCard'

const MobileNonDigitalProductsListing = ({ products, user, productsCount, selectedChildCat }) => {
	return (
		<div className='mt-6 mb-6 container-fluid'>
			<div className='d-flex container-fluid justify-content-between align-items-baseline p-0 mb-4'>
				<div className='col d-flex justify-content-center'>
					<div className='w-100 lh-1 py-2'>
						<div>
							<strong className='text-bold text-md text-black'>{selectedChildCat?.categoryName}</strong>
						</div>
						<div>
							<strong className='text-normal text-xs text-black opacity-5'>{productsCount} Products</strong>
						</div>
					</div>
				</div>
				<div className='col justify-content-end text-end'>
					<div className='d-flex justify-content-end'>
						{/* <div>
							<a
								href=''
								className='fs-6 text-black'
								data-bs-toggle='offcanvas'
								data-bs-target='#offcanvasBottom'
								aria-controls='offcanvasBottom'
							>
								Filters <img src='../../assets/img/svg/filter.svg' className='ms-1' height='16' width='16' alt='' />
							</a>
						</div> */}
					</div>
				</div>
			</div>
			<div className=''>
				<div className='row g-3'>
					{/* Added g-3 for consistent grid gap */}
					{products.map((product) => (
						<div className='col-6' key={product._id}>
							<MobileNonDigitalProductsListingCard product={product} user={user} />
						</div>
					))}
					{products?.length === 0 && (
						<div
							style={{
								display: 'flex',
								justifyContent: 'center',
								alignContent: 'center',
								textAlign: 'center',
							}}
						>
							<h3>No Products Available for selected Category</h3>
						</div>
					)}
				</div>
			</div>
			<div class='offcanvas offcanvas-bottom' tabindex='-1' id='offcanvasBottom' aria-labelledby='offcanvasBottomLabel'>
				<div class='offcanvas-header justify-content-between align-items-baseline mob-bg-smoke'>
					<h6 class='offcanvas-title text-normal text-black' id='offcanvasBottomLabel'>
						Filter ({productsCount} products)
					</h6>
					<button type='button' class='btn-close text-reset' data-bs-dismiss='offcanvas' aria-label='Close'>
						<img src='../../assets/img/svg/close.svg' alt='' />
					</button>
				</div>
				<div class='offcanvas-body small'>
					<MobileFilters />
				</div>
				<div class='offcanvas-footer p-2 justify-content-between align-items-baseline bg-white'>
					<div className='d-flex align-items-baseline gap-3 container-fluid'>
						<div className='col-6'>
							<div>
								<button className='btn btn-lg btn-outline-dark w-100'>Reset</button>
							</div>
						</div>
						<div className='col-6'>
							<button className='btn btn-lg btn-dark w-100'>Apply Filters</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default withNonDigitalProductListingByCategory(MobileNonDigitalProductsListing)
